import ROUTES from '../constants/routes';

/**
 * Helper para navegación programática desde servicios
 *
 * Alternativa segura a window.location.href para navegación
 * desde código fuera de componentes React.
 *
 * @class
 */
class NavigationHelper {
  constructor() {
    this.navigate = null;
  }

  /**
   * Configura la función navigate de React Router
   * @param {Function} navigateFunction - Función de useNavigate()
   */
  setNavigate(navigateFunction) {
    this.navigate = navigateFunction;
  }

  /**
   * Navega a la página de login (usado cuando falla autenticación)
   */
  toLogin() {
    if (this.navigate) {
      this.navigate(ROUTES.LOGIN, { replace: true });
    } else {
      console.warn('Navigate function not available, falling back to window.location');
      window.location.href = ROUTES.LOGIN;
    }
  }

  /**
   * Navega a cualquier ruta
   * @param {string} path - Ruta destino
   * @param {Object} [options={}] - Opciones de navegación
   */
  to(path, options = {}) {
    if (this.navigate) {
      this.navigate(path, options);
    } else {
      console.warn('Navigate function not available, falling back to window.location');
      window.location.href = path;
    }
  }

  /**
   * Verifica si la navegación está disponible
   * @returns {boolean}
   */
  isAvailable() {
    return this.navigate !== null;
  }
}

// Create and export singleton instance
const navigationHelper = new NavigationHelper();
export default navigationHelper;